import React, { useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { STORE_CATEGORY_WRITE_QUERY } from "../Queries";
import { useMutation } from "react-apollo-hooks";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { toast } from "react-toastify";

export default withRouter(({ history, match, location, isModal }) => {
  const modalRef = React.createRef();
  const [storeCategoryWriteMutation] = useMutation(STORE_CATEGORY_WRITE_QUERY);
  const { register, handleSubmit, errors } = useForm();

  const onSubmit = async (data) => {
    try {
      const {
        data: { AdminStoreCategoryWrite },
      } = await storeCategoryWriteMutation({
        variables: {
          pcIcon: data.pcIcon,
          mobileIcon: data.mobileIcon,
          name: data.name,
          isGift: data.isGift === "true" ? true : false,
        },
      });
      if (AdminStoreCategoryWrite) {
        toast.success("설정 되었습니다.");
        history.replace(`/stores/categories${location.search}`);
      }
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };

  useEffect(() => {
    const element = modalRef.current;

    if (isModal) {
      disableBodyScroll(element);
    }

    return () => {
      enableBodyScroll(element);
    };
  });

  return (
    <>
      <Modal
        isOpen={true}
        size={"lg"}
        ref={modalRef}
        toggle={() => {
          history.push(`/stores/categories${location.search}`);
        }}
      >
        <form className="margin-bottom-0" onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader
            toggle={() => {
              history.push(`/stores/categories${location.search}`);
            }}
          >
            분류 등록
          </ModalHeader>
          <ModalBody className=" p-0">
            <div className="form-horizontal form-bordered">
              <div className="bg-white rounded">
                <div className="form-group row">
                  <label className="col-form-label col-md-2">PC 아이콘</label>
                  <div className="col-md-4">
                    <input
                      type="text"
                      name="pcIcon"
                      className="form-control"
                      placeholder="PC 아이콘을 입력해주세요."
                      ref={register({
                        required: "PC아이콘을 입력해주세요.",
                      })}
                    />
                    {errors.pcIcon && <span>{errors.pcIcon.message}</span>}
                  </div>
                  <label className="col-form-label col-md-2">
                    Mobile 아이콘
                  </label>
                  <div className="col-md-4">
                    <input
                      type="text"
                      name="mobileIcon"
                      className="form-control"
                      placeholder="Mobile 아이콘을 입력해주세요."
                      ref={register({
                        required: "Mobile 아이콘을 입력해주세요.",
                      })}
                    />
                    {errors.mobileIcon && (
                      <span>{errors.mobileIcon.message}</span>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-form-label col-md-2">이름</label>
                  <div className="col-md-10">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="이름을 입력해주세요."
                      ref={register({
                        required: "이름을 입력해주세요.",
                      })}
                    />
                    {errors.name && <span>{errors.name.message}</span>}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-form-label col-md-2">드림상점</label>
                  <div className="col-md-10">
                    <div className="checkbox checkbox-css checkbox-inline">
                      <input
                        type="checkbox"
                        id="isGift"
                        name="isGift"
                        value={true}
                        ref={register()}
                      />
                      <label htmlFor="isGift">설정</label>
                      {errors.isGift && <span>{errors.isGift.message}</span>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Link
              to={`/stores/categories${location.search}`}
              className="btn btn-white"
            >
              목록
            </Link>
            <button type="submit" className="btn btn-white text-blue">
              확인
            </button>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
});
